import "../../styles/variables.css";
import "../../styles/normalize.css";
import "../../styles/index.css";
import "../../styles/typography.css";

import { graphql } from "gatsby";
import React, { useState, useEffect } from "react";

import Footer from "../footer/Footer";
import Header from "../header/Header";
import { useWindowSize } from "../../utils/hooks";

const Layout = ({ children, location }) => {
  const windowWidth = useWindowSize().width;
  const isMobile = windowWidth < 1024;

  const tokyoSection = location.pathname.includes("/tokyo/"); /* Tokyo has landing page and B Corp page */
  const caseStudies = location.pathname.includes("/work/");

  return (
    <>
      <Header
        hideNav={tokyoSection}
        tokyo={tokyoSection}
        location={location}
        invertLogo={location.pathname === "/"}
        background={caseStudies}
      />
      <main id="main-content">{children}</main>
      <Footer location={location} />
    </>
  );
};

export default Layout;

export const query = graphql`
  fragment ChunkFields on ContentfulChunk {
    id
    name
    title
    image {
      id
      title
      file {
        url
      }
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, quality: 90)
    }
    gallery {
      id
      title
      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      file {
        url
      }
    }
    video {
      ...VideoFields
    }
    content {
      childMarkdownRemark {
        html
      }
    }
    furtherContent {
      childMarkdownRemark {
        html
      }
    }
    list {
      ... on ContentfulListItem {
        id
        title
        content {
          childMarkdownRemark {
            html
          }
        }
        image {
          title
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          file {
            url
          }
        }
        reference {
          ... on ContentfulPost {
            id
            title
            description
            image {
              title
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
          }
          ... on ContentfulExternalLink {
            id
            title
            description
            image {
              title
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
              file {
                url
                contentType
              }
            }
          }
          ... on ContentfulPage {
            id
            title
            description
            image {
              title
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
          }
        }
      }
      ... on ContentfulStudio {
        id
        addressLine1
        addressLine2
        city
        country
        telephone
        email
        gmap
        order
        photo {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, quality: 80)
        }
      }
      ... on ContentfulStat {
        id
        title
        copy
        star
      }
      ... on ContentfulExternalLink {
        id
        title
        description
        image {
          title
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          file {
            url
            contentType
          }
        }
      }
    }
    reference {
      ... on ContentfulPost {
        id
        title
        description
        image {
          title
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      ... on ContentfulExternalLink {
        id
        title
        description
        image {
          title
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      ... on ContentfulPage {
        id
        name
        title
        description
        image {
          title
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
    posts {
      ... on ContentfulPost {
        id
        title
        description
        image {
          title
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      ... on ContentfulPage {
        id
        title
        description
        image {
          title
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  }
`;
